/**
 * Specialty / scope helpers for the pathopod fork.
 *
 * Pathopod is a single-modality product (pathology only), so the
 * scope is fixed at compile time. The legacy multi-specialty scope
 * code + patient/referring MRN-narrowing are RETIRED with the move
 * to the 4-role RBAC matrix in 07-rbac-matrix.md.
 */

import type { AuthState } from "./types";
import { canUserUi } from "./types";
import type { Specialty } from "../specialty/config";

/** This modality's specialty — pathology. */
export const MODALITY_SPECIALTY: Specialty = "pathology";

/** DICOM Modality codes this product handles (slide microscopy). */
export const MODALITY_CODES: ReadonlyArray<string> = ["SM", "GM"];

export function canSeeSpecialty(auth: AuthState | null, s: Specialty): boolean {
  return canUserUi(auth) && s === MODALITY_SPECIALTY;
}

export function singleSpecialty(auth: AuthState | null): Specialty | null {
  return canUserUi(auth) ? MODALITY_SPECIALTY : null;
}

export function modalitiesInScope(_auth: AuthState | null): Set<string> {
  return new Set(MODALITY_CODES);
}
